import React from 'react'
import { TeamCard, TeamIcon, TeamP, TeamWrapper, TeamContainer, TeamTitle, TeamH2 } from './TeamElements'


const Team = () => {
    return (
        <TeamContainer id="Team">
            <TeamTitle>TEAM</TeamTitle>
            <TeamWrapper>
                    
                    <TeamCard >
                    {/* <a href="https://imgur.com/xlx4gPk"><img src="https://i.imgur.com/xlx4gPk.png" title="source: imgur.com" /></a> */}
                        <TeamIcon src="https://i.imgur.com/xlx4gPk.png" />
                        <TeamH2>RK / Project Lead</TeamH2>
                        <TeamP>Functioning 24/7.</TeamP>
                    </TeamCard>

                    <TeamCard  >
                    {/* <a href="https://imgur.com/QIRM7Rk"><img src="https://i.imgur.com/QIRM7Rk.png" title="source: imgur.com" /></a> */}
                        <TeamIcon src="https://i.imgur.com/QIRM7Rk.png" />
                        <TeamH2>Sleepy J / Artist</TeamH2>
                        <TeamP>Everything is delicious as long as you add salt.</TeamP>
                    </TeamCard>

                    <TeamCard  >
                    {/* <a href="https://imgur.com/jj2DErv"><img src="https://i.imgur.com/jj2DErv.png" title="source: imgur.com" /></a> */}
                        <TeamIcon src="https://i.imgur.com/jj2DErv.png" />
                        <TeamH2>Foodie F/ Artist</TeamH2>
                        <TeamP>A sleepy foodie<br/>that needs some alcohol.</TeamP>
                    </TeamCard>

                    <TeamCard >
                    {/* <a href="https://imgur.com/KdK2ItI"><img src="https://i.imgur.com/KdK2ItI.jpg" title="source: imgur.com" /></a> */}
                        <TeamIcon src="https://i.imgur.com/KdK2ItI.jpg"  />
                        <TeamH2>Mur＊＊ / Dev</TeamH2>                       
                        <TeamP>A Schwarzwälder Kirschtorte lover with a small killifish.</TeamP>
                    </TeamCard>

                    <TeamCard  >
                    {/* <a href="https://imgur.com/O7NDd0r"><img src="https://i.imgur.com/O7NDd0r.jpg" title="source: imgur.com" /></a> */}
                        <TeamIcon src="https://i.imgur.com/O7NDd0r.jpg"  />
                        <TeamH2>Sen / Dev</TeamH2>
                        <TeamP>Nerdy life struggler.</TeamP>
                    </TeamCard>
                    
                </TeamWrapper>
            
        </TeamContainer>
    )
}

export default Team